import { default as invoiceMinus } from "../../../icons/invoiceMinus.svg";

import React, {useEffect, useState} from "react";
import "../InvoicePage.scss";
import { useContent, useLanguages } from "../../../hooks/content";
import { Returntext } from "../../Landings/common/returnText";

function InvoiceCustomerComponent({ props }) {
    const { lang } = useLanguages();
    const { contentManagementData } = useContent();
    const [data, setData] = useState(null);

    useEffect(() => {
        setData({
            name: {
                key: Returntext(contentManagementData, 'poi_content_customer_name', lang),
                value: `${ props.first_name } ${ props.last_name }`
            },
            phone: {
                key: Returntext(contentManagementData, 'poi_content_customer_phone', lang),
                value: props.phone
            },
            email: {
                key: Returntext(contentManagementData, 'poi_content_customer_email', lang),
                value: props.email
            },
            room: {
                key: Returntext(contentManagementData, 'poi_content_customer_room_number', lang),
                value: props.room_number
            },
        })
    }, [lang])

    return (
        <div className="invoice-sheet">
            <div className="invoice-title">
                <span>{ Returntext(contentManagementData, 'poi_sheet_title_customer', lang) }</span>
                <img src={invoiceMinus} alt="minus"/>
            </div>
            <div className="invoice-sheet-container">
                <div className="invoice-item">
                    <div>{ data?.name.key }</div>
                    <div>{ data?.name.value }</div>
                </div>
                <div className="invoice-item">
                    <div>{ data?.phone.key }</div>
                    <div>{ data?.phone.value }</div>
                </div>
                <div className="invoice-item">
                    <div>{ data?.email.key }</div>
                    <div>{ data?.email.value }</div>
                </div>
                <div className="invoice-item">
                    <div>{ data?.room.key }</div>
                    <div>{ data?.room.value }</div>
                </div>
            </div>
        </div>
    )
}

export default InvoiceCustomerComponent;